import conf from './config'
import rest from "./rest.js"
import { restify } from './mixins'


// Restify all Models
import { 
  Account, 
  Session, 
  RecordDef, 
  ReportDef,
  Connector 
} from '@/models'

const accounts = restify(Account, { 
  endpoint: () => '/account', 
  methods: "get" 
})

const sessions = restify(Session, { 
  endpoint: () => '/session', 
  methods: "post,get" 
})

const recordDefs = restify(RecordDef, {
  endpoint: (uid) => '/record-defs'+(uid ? '/'+uid : ''), 
  methods: "collection,get" 
})

const reportDefs = restify(ReportDef, {
  endpoint: (uid) => '/report-defs'+(uid ? '/'+uid : ''), 
  methods: "collection,post,get,put,delete,upload" 
})

const connectors = restify(Connector, {
  endpoint: (uid) => '/conn'+(uid ? '/'+uid : ''), 
  methods: "collection,get,put,delete,upload" 
})

export default {
  ...conf,
  ...rest,
  accounts,
  recordDefs,
  reportDefs,
  connectors,
  sessions
}
